import React from "react";
import "./Footer.css";
import linkdin from '../../assets/linkedin.png'; // Ensure these paths are correct
import github from '../../assets/github.png';
import instagram from '../../assets/instagram.png';
import logo from '../../assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Dynamically get the current year

  return (
    <div className="FooterContainer"> {/* Renamed for clarity and consistency */}
      <hr /> {/* The separator line at the top of the footer */}

      <div className="footer-content"> {/* New div to group social links and logo */}
        <div className="social-links"> {/* Renamed from 'footer' for better clarity */}
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
            <img src={instagram} alt="Instagram" />
          </a>
          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
            <img src={linkdin} alt="LinkedIn" />
          </a>
          <a href="https://github.com/" target="_blank" rel="noopener noreferrer">
            <img src={github} alt="GitHub" />
          </a>
        </div>

        <div className="logo-footer">
          <img src={logo} alt="Fitness Logo" />
        </div>
      </div>

      <div className="copyright">
        <span>&copy; {currentYear} Muzammal Muzammal. All rights reserved.</span>
      </div>
    </div>
  );
};

export default Footer;